// delivery-timeline.js
(() => {
  const initTimeline = () => {
    const timelines = document.querySelectorAll('.delivery-timeline-wrapper');
    
    if (timelines.length === 0) return;

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const getOrdinalSuffix = (i) => {
      let j = i % 10,
          k = i % 100;
      if (j === 1 && k !== 11) return "st";
      if (j === 2 && k !== 12) return "nd";
      if (j === 3 && k !== 13) return "rd";
      return "th";
    };

    const formatDate = (dateObj) => {
      const month = monthNames[dateObj.getMonth()];
      const day = dateObj.getDate();
      return `${month} ${day}${getOrdinalSuffix(day)}`;
    };

    timelines.forEach(wrapper => {
      if (wrapper.dataset.timelineInitialized) return;
      wrapper.dataset.timelineInitialized = "true";

      const rawMin = wrapper.dataset.minDays;
      const rawMax = wrapper.dataset.maxDays;
      
      const minDays = rawMin !== undefined && rawMin !== "" ? Number(rawMin) : 3;
      const maxDays = rawMax !== undefined && rawMax !== "" ? Number(rawMax) : 7;

      const today = new Date();
      const minDate = new Date();
      minDate.setDate(today.getDate() + minDays);
      
      const maxDate = new Date();
      maxDate.setDate(today.getDate() + maxDays);

      const todayFormatted = formatDate(today);
      const minDateFormatted = formatDate(minDate);
      const maxDateFormatted = formatDate(maxDate);

      const todayEls = wrapper.querySelectorAll('.dt-today');
      todayEls.forEach(el => el.textContent = todayFormatted);

      const minDateEls = wrapper.querySelectorAll('.dt-min-date');
      minDateEls.forEach(el => el.textContent = minDateFormatted);

      const maxDateEls = wrapper.querySelectorAll('.dt-max-date');
      maxDateEls.forEach(el => el.textContent = maxDateFormatted);
    });
  };

  // Run immediately (since script is deferred or loaded dynamically)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimeline);
  } else {
    initTimeline();
  }
  
  // Re-init in case of Shopify theme editor changes
  document.addEventListener('shopify:section:load', initTimeline);
})();
